import React, { useState, useMemo, useEffect } from 'react';
import { Button, List, Card, CardHeader, CardBody } from 'reactstrap';
import _ from 'lodash';

import deduplicate from '../util/deduplicate';
import {ERRORS_KEY} from '../util/formValidation';


function ErrorListTemplate({ errorSchema }) {
    const errors = useMemo(() => {
        if (!errorSchema) return [];

        const errors = [];
        const stack = [["", "", errorSchema]];
        while (stack.length) {
            const [prefix, name, current] = stack.shift();
            Object.entries(current).forEach(([key, value]) => { if (key === ERRORS_KEY) {
                value = value.filter(x => x !== 'should be equal to constant');
                if (prefix && value.length) {
                    deduplicate(value).forEach(v => errors.push({
                        fieldId: makeFieldId(prefix),
                        name,
                        msg: v
                    }));
                }
            } else {
                stack.push([prefix ? `${prefix}.${key}` : key, key, value]);
            }});
        }

        return errors;
    }, [errorSchema]);

    return (
        <Card className="form-errors">
            <CardHeader className="title">
                Errores
            </CardHeader>
            <List className="form-error-list" type="unstyled">{(errors || []).map((error, idx) => (
                <ErrorItem key={idx} err={error} />
            ))}</List>
        </Card>
    );
}


function ErrorItem({err}){
    const [hide, setHide] = useState();
    const {fieldId, name, msg} = err;
    useEffect(() => {setHide();}, [err]);

    function onClickError(e){
        e.preventDefault();

        const element = document.getElementById(fieldId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    return (<li className="error-item">
        <Button color="clear" className="text-left" onClick={onClickError}>
            {name} {msg}
        </Button>
    </li>);
}


function makeFieldId(field){
    return `root_${field.replace(/^\./, '').replaceAll('.', '_')}`;
}

export default ErrorListTemplate;